import { gql } from 'apollo-angular';

export const LIST_ALL_PROPERTIES_WITH_PAGINATION = gql`
  query findAllPropertiesWithPagination(
    $propertyPaginationInput: PropertyPaginationInput
  ) {
    findAllPropertiesWithPagination(
      propertyPaginationInput: $propertyPaginationInput
    ) {
      properties {
        id
        branchId
        propertyName
        address
        annualRent
        vacancies
        balanceVacancies
        status
        createdAt
        updatedAt
      }
      total
      skip
      limit
    }
  }
`;

export const GET_PROPERTY_BY_ID = gql`
  query property($id: Int!) {
    property(id: $id) {
      id
      branchId
      propertyName
      address
      annualRent
      vacancies
      status
      createdAt
      updatedAt
    }
  }
`;

export const GET_EMPLOYEES_IN_PROPERTY = gql`
  query getEmployeesInProperties(
    $propertyEmployeesPaginationInput: PropertyEmployeesPaginationInput
  ) {
    getEmployeesInProperties(
      propertyEmployeesPaginationInput: $propertyEmployeesPaginationInput
    ) {
      propertyAllocations {
        propertyId
        propertyName
        employees {
          allocationId
          employeeId
          employeeName
          startDate
          endDate
          isActive
          daysOccupied
        }
      }
      total
      skip
      limit
    }
  }
`;

export const MONTHLY_RENT_SUMMARY = gql`
  query monthlyRentSummary(
    $year: Int!
    $month: Int!
    $propertyId: Int
    $employeeName: String
  ) {
    monthlyRentSummary(
      year: $year
      month: $month
      propertyId: $propertyId
      employeeName: $employeeName
    ) {
      monthlyRentSummary {
        employeeId
        employeeName
        propertyId
        propertyName
        monthlyRent
      }
      totalRent
    }
  }
`;
